import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import Button from '@material-ui/core/Button';
import { getGeneralById } from "../../functions/general"
import { useSelector } from 'react-redux';
import { putGeneral } from "../../functions/general"
const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',

        borderRadius: '10px',
        padding: '10px',
        boxShadow: '0px 0px 10px #00000029',
        position: 'relative',
        zIndex: '1',
    },
    list: {
        listStyle: 'none',
        padding: '0',
        margin: '0',

    },
    vote: {

        width: '100%',
        margin: '10px',
        backgroundColor: '#f5f5f5',
        //  borderRadius: '10px',
        border: '1px solid #e5e5e5',
        textAlign: 'center',
        lineHeight: '30px',
        borderRadius: '10px',


        "&:hover": {
            cursor: 'pointer',
            borderColor: theme.palette.primary.main,


        },

    },
    img: {
        width: "40px",
        zIndex: 3
    },
    button1: {
        color: '#fff',
        backgroundColor: theme.palette.primary.main,
        //borderRadius: '10px',

    },
    button2: {
        color: '#fff',
        backgroundColor: theme.palette.secondary.main,
        //borderRadius: '10px',

    },
    progressbarContainer: {
        position: "relative",
        width: "100%",
        height: "50px",
        overflow: "hidden",
        border: "1px solid #FFF",
        borderRadius: "10px",
        display: " flex",
        alignItems: "center",
        justifyContent: "space-between",
        margin: "10px 0",
    },
    progressbarComplete: {
        position: "absolute",
        left: 0,
        top: "0px",
        height: "100%",
        backgroundColor: "#3ad1bf",
        borderRadius: "10px",
        animation: "$g 5000ms infinite ease-in-out",
        zIndex: 2
    },
    progressbarLiquid: {
        zIndex: 1,
        width: "70px",
        height: "70px",
        animation: "$g 5000ms infinite ease-in-out, $r 3000ms infinite cubic-bezier(0.5, 0.5, 0.5, 0.5)",
        position: "absolute",
        right: "-5px",
        top: "-10px",
        backgroundColor: "#3ad1bf",
        borderRadius: "40%",
    },
    progress: {
        zIndex: 2
    },
    "@keyframes g": {
        "0%": { backgroundColor: "#C9F7F2" },
        "50%": { backgroundColor: "#3ad1bf" },
        "100%": { backgroundColor: "#B6E9ED" }
    },
    "@keyframes r": {
        from: { transform: "rotate(0deg)" },
        to: { transform: "rotate(360deg)" }
    }


}));


const Vote = ({ content, participants_userids, open, _id, done }) => {

    //   console.log("hihi")
    const { user: { userID } } = useSelector(state => ({ ...state }));
    const styles = useStyles();
    const [polls, setPolls] = useState([...content]);
    const [checked, setChecked] = useState(Array.from(polls, x => x.participants_userids.includes(userID) ? 1 : 0));
    const [participated, setParticipated] = useState(false);
    //  const [submit, setSubmit] = useState(false);

    useEffect(() => {
        console.log("useEffect")
        if (open) {
            // console.log(open)
            getGeneralById(_id).then(res => {
                setParticipated(res.participants_userids.includes(userID))
                setPolls([...res.polls])
                setChecked(Array.from(res.polls, x => x.participants_userids.includes(userID) ? 1 : 0))
            }).catch(err => {
                console.log(err)
            }
            )
        }
        return () => {
            console.log("unmount")
        }
    }, []);

    const onSubmit = async () => {
        try {
            const general = { userID, bitarray: checked }

            const { message } = await putGeneral(_id, general)

            if (message === "updated") {
                setParticipated(true)
                //  setSubmit(true)
                return;
            }

            throw new Error("error")

        } catch (e) {

            console.log(e)

        }
    }

    const handleToggle = (index) => () => {
        //console.log(index)
        setChecked(prev => {
            const newChecked = [...prev];
            newChecked[index] = newChecked[index] === 0 ? 1 : 0;
            return newChecked;
        });
        //console.log(checked)
    };

    const voteAgain = () => {
        // console.log("voteAgain")
        setParticipated(false);
        // setSubmit(true ? false : true);
    }

    return (
        <>
            {participated || done ?
                <>
                    {
                        polls.map((value, index) => {
                            return (
                                <div key={index} className={styles.progressbarContainer}>
                                    <div className={styles.progressbarComplete} style={{ width: `${value.participants_userids.length * 100 / participants_userids.length}%` }}>
                                        <div className={styles.progressbarLiquid}></div>
                                    </div>
                                    <span className={styles.progress}>{value.content}</span>
                                    {value.image === null ? <ImageOutlinedIcon fontSize="large" style={{ zIndex: 3 }} /> : <img src={value.image} alt="njd" className={styles.img} />}
                                </div>
                            )
                        })
                    }
                    <div style={{ textAlign: "center" }}>
                        {done ?
                            <Button size='large' variant="contained" >종료</Button>
                            :
                            <Button size='large' variant="contained" className={styles.button2} onClick={voteAgain}>다시 투표하기</Button>
                        }
                    </div>
                </>

                :
                <>
                    <List className={styles.root}>
                        {polls.map((value, index) => {
                            const labelId = `checkbox-list-label-${value.content}`;
                            return (
                                <ListItem key={index} role={undefined} dense button onClick={handleToggle(index)}>
                                    <ListItemIcon>
                                        <Checkbox
                                            edge="start"
                                            checked={checked[index] === 1 ? true : false}
                                            tabIndex={-1}
                                            disableRipple
                                            inputProps={{ 'aria-labelledby': labelId }}
                                            color="primary"
                                        />
                                    </ListItemIcon>
                                    <ListItemText id={labelId} primary={`${value.content}`} />
                                    <ListItemSecondaryAction>
                                        {value.image === null ? <ImageOutlinedIcon fontSize="large" /> : <img src={value.image} alt="njd" className={styles.img} />}
                                    </ListItemSecondaryAction>
                                </ListItem>
                            );
                        })}
                    </List>
                    <div style={{ textAlign: "center" }}>
                        <Button size='large' variant="contained" className={styles.button1} onClick={onSubmit}>투표하기</Button>
                    </div>
                </>
            }
        </>
    );
};

export default Vote;